import { useAppSelector } from 'store/hooks';

export const useCachedUserType = () => {
  const userType = useAppSelector(state => state.user.userType);

  return {
    userType,
    isKa: userType === 'ka',
    isDirect: userType === 'direct',
  };
};
